<div class="title-block mb-3">
  <h4 class="card-title">{{ 'TR_ORGANIZATION_SETTINGS' | translate }}</h4>
</div>

<div class="row">
  <div class="col-lg-4 col-md-4 col-sm-6 col-12" *ngFor="let educationLevel of educationLevels;index as educationLevelIndex ">
    <div *ngIf="educationLevel.isActive" class="main-card mb-3 card">
      <div class="table-responsive">
        <table class="align-middle mb-0 table table-striped table-hover">
          <thead>
            <tr>
              <th>{{ educationLevel.name | translate }}</th>
              <th *ngIf="educationLevelIndex > 1" class="text-right">{{ 'TR_ACTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="educationLevelIndex > 1">
              <td>
                <input
                  name="name"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  [placeholder]="'TR_NAME' | translate"
                  [(ngModel)]="educationLevel.inputValue"
                />
              </td>
              <td class="level-table-btns text-right">
                <app-save-button
                  *ngIf="education_levels_create"
                  [spinnerId]="submitSpinnerId"
                  [isCurrent]="submitEducationLevelIndex === educationLevelIndex"
                  [buttonClasses]="'small-padding mb-1 mr-1 btn-transition btn btn-outline-primary'"
                  (submit)="submitData(educationLevelIndex)"
                  [isDisabled]="updateValue && educationLevel.content[0]?.parentId != blockId ? true : false"
                  ></app-save-button>
                <button
                 class="mb-1 btn-transition btn btn-outline-danger"
                  [title]="'TR_CANCEL' | translate"
                   (click)="cancel(educationLevel)"
                   [disabled]="updateValue && educationLevel.content[0]?.parentId != blockId ? true : false"
                   >
                  <i class="pe-7s-close-circle"></i>
                </button>
              </td>
            </tr>
            <tr [class.selected]="educationLevelValue.selected" *ngFor="let educationLevelValue of educationLevel.content">
              <td class="clickable" class="pointer" (click)="openNextEducationLevel(educationLevel, educationLevelValue, educationLevelIndex, lecturerview)">
                {{ educationLevelValue.name }}
              </td>
              <td *ngIf="educationLevelIndex > 1" class="level-table-btns text-right">
                <button
                  *ngIf="education_levels_update"
                  class="mb-1 mr-1 btn-transition btn btn-outline-info"
                  [title]="'TR_UPDATE' | translate"
                  (click)="edit(educationLevelValue, educationLevelIndex, educationLevel.content)"
                  [disabled]="updateValue ? true : false"
                  >
                  <i class="pe-7s-note"></i>
                </button>
                <button
                  *ngIf="education_levels_delete"
                  class="mb-1 btn-transition btn btn-outline-danger"
                  [title]="'TR_DELETE' | translate"
                  (click)="confirmDelete(deleteconfirm, educationLevelValue, educationLevelIndex)"
                >
                  <i class="pe-7s-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteconfirm let-c="close" let-d="dismiss">
  <div class="custom-modal modal-body">
    <p>{{ 'TR_DELETE_ERROR' | translate }} <b>{{ deleteLevelValueName }}</b>?</p>
  </div>
  <div class="custom-modal modal-footer">
    <app-action-button
      [isCurrent]="true"
      [spinnerId]="deleteSpinnerId"
      buttonClasses="btn-transition btn btn-outline-primary"
      spinnerClasses="small-button-spinner"
      [buttonName]="'TR_YES'"
      (clicked)="delete()"
    ></app-action-button>
    <button type="button" class="btn-transition btn btn-danger" (click)="c('Close click')">{{ 'TR_NO' | translate }}</button>
  </div>
</ng-template>

<ng-template #lecturerview let-c="close" let-d="dismiss">
  <app-subject-lecturer [subjectId]="selectedSubjectId" [subjectName]="selectedSubjectName" (closeEmit)="c('Close click')"></app-subject-lecturer>
</ng-template>
